module.exports = "pegasus_template/assets/tech/realty/103.png";